<template>
  <div class="complaint">
    <div class="header-title">投诉课程</div>
    <div class="shop-info">
      <div class="img-con">
        <img class="img" :src="shopDetail.shopAvatar + '?imageView2/0/w/60/h/60'" alt="">
      </div>
      <div class="shop-name">{{ shopDetail.shopName }}</div>
    </div>
    <div class="goods-con">
      <div class="goods">
        <div class="img-con">
          <img class="img" :src="goodsData.coverPath + '?imageView2/0/w/140/h/100'" alt="">
        </div>
        <div class="title-con">
          <div class="title"><span class="type">{{ knowledgeTypeName(goodsData.courseType) }}</span>{{ goodsData.title }}</div>
          <div class="sub-text">
            <div class="num-con" v-if="goodsData.courseType===null || goodsData.courseType==='VIDEO' || goodsData.courseType==='AUDIO'">
              <span class="num" v-if="goodsData.courseType===null">共{{ goodsData.planCourseCount }}期 <span v-if="goodsData.currentCourseCount">，已更新至{{ goodsData.currentCourseCount }}期</span></span>
              <span class="num" v-if="goodsData.courseType!==null">时长:{{ formatSeconds(goodsData.courseType ,goodsData.duration) }}</span>
            </div>
            <div v-if="goodsData.courseType!==null && goodsData.courseType!=='VIDEO' && goodsData.courseType!=='AUDIO'">
              <span class="num" style="color: #f74d4d;">开播时间:{{ goodsData.startTime }}</span>
            </div>
            <!--<span class="num">收藏:{{ goodsData.collectUserCount }}</span>
            <span class="num">已售:{{ goodsData.salesVolume }}</span>-->
          </div>
        </div>
      </div>
    </div>

    <van-form
        ref="form"
        label-align="center"
        @submit="onSubmit"
    >
      <div class="header-title">投诉内容</div>
      <van-field
          v-model="reason"
          clearable
          type="textarea"
          rows="4"
          maxlength="200"
          show-word-limit
          placeholder="请输入投诉内容"
          :rules="[{required: true, message: '必填'}]"
      >
      </van-field>
      <div class="header-title">请填写您的个人信息，方便可以联系您</div>
      <van-field
          v-model="tel"
          type="number"
          label="手机号码"
          label-width="70px"
          placeholder="（选填）"
      ></van-field>
      <div class="btn-con" style="padding: 20px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { columnDetail, courseDetail, directDetail, complaintGoods } from '@/api/mall/mallGoods'
import { introduce } from '@/api/mall/mallShop'
export default {
  components:{
  },
  data(){
    return{
      shopDetail: {},
      goodsData: {},

      reason: '',
      tel: '',
    }
  },
  created(){
    this.getShopHome()

    if(this.$route.query.courseType === null){ // 专栏
      this.getColumnDetail()
    }else if( this.$route.query.courseType === 'VIDEO' || this.$route.query.courseType === 'AUDIO' ){ // 课程
      this.getCourseDetail()
    }else if(this.$route.query.courseType==='LIVE_VOICE' || this.$route.query.courseType==='LIVE_IMAGE_TEXT'
      || this.$route.query.courseType==='LIVE_EDUCATION' || this.$route.query.courseType==='LIVE_INTERACTIVE_VIDEO'){ // 直播
      this.getDirectDetail()
    }
  },
  methods: {
    //获取店铺信息
    getShopHome() {
      introduce({shopId: this.$route.query.shopId}).then(res=>{
        this.shopDetail = res.data || {};
      })
    },
    getColumnDetail() { // 专栏详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      columnDetail(req).then(res=>{
        this.goodsData = res.data || {};
        this.goodsData.courseType = null;
      })
    },
    getCourseDetail() { // 课程详情(视频，音频)
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      courseDetail(req).then(res=>{
        this.goodsData = res.data || {};
        this.goodsData.courseType = res.data.type;
      })
    },
    getDirectDetail() { // 直播详情
      let req = { goodsId: this.$route.query.goodsId, shopId: this.$route.query.shopId };
      directDetail(req).then(res=>{
        this.goodsData = res.data || {};
      })
    },


    onSubmit(){
      this.$refs['form'].validate().then(()=>{
        let req = {
          // complaintPictureList: [
          //   {complaintReasonContent: ''}, //图片路径
          // ],// 投诉图片/截图
          reason: this.reason,// 投诉内容
          goodsComplaintReasonId: this.session('goodsComplaintReasonId'), // 投诉理由id
          goodsId: this.$route.query.goodsId,
          goodsVersionNo: this.goodsData.goodsVersionNo, //快照版本号
        };
        this.tel && (req.tel = this.tel) // 投诉人手机号
        // console.log(req)
        complaintGoods(req).then(res=>{
          if(res.code===200){
            this.$toast('投诉反馈成功！')
            this.$router.go(-2)
          }else {
            this.$toast(res.message)
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.complaint{
  .header-title{
    background-color: #f5f5f5;
    line-height: 35px;
    font-size: 14px;
    color: #999;
    padding: 0 14px;
  }

  .shop-info{
    font-size: 14px;
    display: flex;
    height: 44px;
    align-items: center;
    .img-con{
      padding: 0 12px;height: 100%;
      display: inline-flex;justify-content: center;align-items: center;
      .img{
        width: 30px;height: 30px;border-radius: 50%;display: block;
      }
    }
  }

  .goods-con{
    font-size: 14px;
    .goods{
      display: flex;
      height: 70px;
      border-bottom: .5px solid #edecec;
      /*background-color: #edecec;*/
      .img-con{
        width: 88px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        .img{
          display: block;
          width: 70px;
          height: 50px;
        }
      }
      .title-con{
        flex: 1;
        overflow: hidden;
        padding: 2px 12px 0 0;
        display: inline-flex;
        justify-content: center;
        /*align-items: center;*/
        flex-direction: column;
        .title{
          /*height: 38px;*/
          padding-bottom: 2px;
          margin-bottom: 4px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          .type{
            margin: 0 5px 0 0;
            font-size: 9px;
            border: .75px solid #1585f3;
            color: #1585f3;
            border-radius: 2px;
            padding: 1px 2.5px;
          }
        }
        .sub-text{
          font-size: 12px;
          color: #7d7e80;
          .num-con{
            padding-bottom: 4px;
          }
          .num{padding-right: 24px;}
        }
      }
    }
  }

  .count-con{
    font-size: 12px;
    color: #cdcdcd;
    position: relative;
    text-align: right;
    padding: 0 12px;
    .count{

    }
  }
}
</style>